<template>
  <div class="noOpTable" :style="{'min-height':tableHeight}">
     <el-table
        :data="tableData"
        border
        :height="height"
        style="width: 100%"
        :cell-style="{ color: '#222' }"
        header-row-class-name="tableHead"
        >
      
           <el-table-column
            prop="index" label="序号" width="100" v-if="indexFlag"
            >
            
            <template slot-scope="scope">
              {{(scope.$index+1)+(currentPage-1)*pageSize}}
            </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in tableHead"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>
            <el-empty :description="emptyTip" v-show="tableData.length==0"></el-empty>
  </div>
</template>

<script>
export default {
    name:"NoOpTable",
    props:{
      // 当前页数
        currentPage:{
           default:1
        },
        // 每页条数
        pageSize:{
            default:10
        },
        // 表头
        tableHead:{
            type:Array,
            default:[]
        },
        // 表数据
        tableData:{
            type:Array,
            default:[]
        },
        emptyTip:{
          type:String,
          default:"暂无数据"
        },
        // 表格高度
        tableHeight:{
          type:String,
          default:"652px"
        },
        // 是否需要第一列序号
        indexFlag:{
          type:Boolean,
          default:true
        },
        // 高度
        height:{
           type:Number,
           default:0
        }
    }
}
</script>

<style lang="scss">
    .noOpTable{
    width: 100%;
    min-height: 652px;
    // border-left:1px solid #dfe9f2 ;
    // border-right:1px solid #dfe9f2 ;
    // border-bottom:1px solid #dfe9f2 ;
      /**改变表格内竖线颜色*/
      .el-table--border td,
      .el-table--border th,
      .el-table__body-wrapper
        .el-table--border.is-scrolling-left
        ~ .el-table__fixed {
        border-right: 1px solid #dfe9f2 !important;
      }
      /**改变表格内行线颜色*/
      .el-table td,
      .el-table th.is-leaf {
        border-bottom: 1px solid #dfe9f2 !important;
      }

      .el-table thead tr th {
        border-color: #dfe9f2;
        font-family: Source Han Sans CN;
      }
      //   设置行高和表头行高
      .el-table__header tr,
      .el-table__header th {
        padding: 0;
        height: 50px;
        line-height: 50px;
      }
      .el-table__body tr,
      .el-table__body td {
        padding: 0;
        height: 50px;
        line-height: 50px;
      }
      //滚动条的宽度

      .el-table__body-wrapper::-webkit-scrollbar {
        width: 18px;

        height: 18px;
      }

      //滚动条的滑块

      .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #dce3f2;

        border-radius: 9px;
        border:4px solid #fff;
        box-sizing:border-box;
      }
      .el-table__empty-block{
        display: none;
      }
      .el-table {
        .tableHead {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #222222;
          background: #f2f7ff;
          .el-table__cell {
            background: transparent;
          }
        }
      }
    }
</style>